import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import styled, { css } from "styled-components";

export const IssueTopicCardButtonWrapper = styled(Button)<{
  $isSelected?: boolean;
  $homePage?: boolean;
}>`
  border-radius: 4px;
  padding: ${getSpacing("2x")};
  cursor: pointer;
  text-align: left;
  border: ${(props) => {
    return props.$isSelected
      ? css`1px solid ${Core.border.default}`
      : css`1px solid ${Core.border.muted}`;
  }};

  background-color: ${(props) => {
    return props.$isSelected ? Core.surface.muted : Core.surface.inverse;
  }};

  &:hover {
    border: 1px solid ${Core.border.default};
    background-color: ${Core.surface.inverse};
  }
  min-width: 148px;
  width: 100%;
  height: auto;
`;

export const IssueTopicCardInnerWrapper = styled(Column)`
  width: 100%;
  flex-wrap: wrap;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  text-align: center;
  & svg {
    color: ${Core.icon.subdued} !important;
  }
`;

export const TypographyWrapper = styled(Typography).attrs({
  variant: "paragraphSansMedium",
})`
  &&& {
    color: ${Core.text.default} !important;
  }
`;
